<ui-web-page-title pageTitle="Ministries" *ngIf="showPageTitle" class="container-fluid ui-web-page-title"></ui-web-page-title>

<div class="container-fluid ui-web-ministries">
    <div class="container">
        <div class="row ui-web-ministries__content">
            <div class="col-lg-3 col-12 ui-web-ministries__content__col">
                <div class="ui-web-ministries__content__card">
                    <img src="assets/img/dove.webp" alt="Ministries" />
                    <h2>Divine Outreach Ministry</h2>
                    <span>
                        Proclaiming the Gospel through Retreats and Conventions held at different parishes.
                        <a routerLink="/home/contact-us">Contact for more information.</a>
                    </span>
                </div>
            </div>
            <div class="col-lg-3 col-12 ui-web-ministries__content__col">
                <div class="ui-web-ministries__content__card">
                    <img src="assets/img/dove.webp" alt="Ministries" />
                    <h2>Intercessory & Healing Prayer Ministry</h2>
                    <span>Team members are interceding unceasingly for the world.</span>
                </div>
            </div>
            <div class="col-lg-3 col-12 ui-web-ministries__content__col">
                <div class="ui-web-ministries__content__card">
                    <img src="assets/img/dove.webp" alt="Ministries" />
                    <h2>Children & Teens Prayer Service</h2>
                    <span>A faith formation program that focus on bringing children close to the Lord.</span>
                </div>
            </div>
            <div class="col-lg-3 col-12 ui-web-ministries__content__col">
                <div class="ui-web-ministries__content__card">
                    <img src="assets/img/dove.webp" alt="Ministries" />
                    <h2>Friday Prayer & Retreats Ministry</h2>
                    <span>A day of prayer with Holy Mass, Confession, Preaching the Word of God, and Healing Adoration.</span>
                </div>
            </div>
        </div>
    </div>
</div>